module.exports = __webpack_public_path__ + "static/media/PATS_1-370w.2536b709.png";